import { render, staticRenderFns } from "./DutyPartsView.vue?vue&type=template&id=66a89c02&scoped=true&"
import script from "./DutyPartsView.vue?vue&type=script&lang=js&"
export * from "./DutyPartsView.vue?vue&type=script&lang=js&"
import style0 from "./DutyPartsView.vue?vue&type=style&index=0&id=66a89c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a89c02",
  null
  
)

export default component.exports